import request from '@/utils/request';

const jsonHeaders = { headers: { 'Content-Type': 'application/json' } };

export function fetchLocations() {
  return request.get('locations/get');
}

export function createLocation(payload) {
  return request.post('locations/add', payload, jsonHeaders);
}

export function updateLocation(id, payload) {
  return request.put(`locations/update/${id}`, payload, jsonHeaders);
}

export function deleteLocation(id) {
  return request.delete(`locations/delete/${id}`);
}

export function updateLocationPassword(id, payload) {
  return request.put(`locations/update-password/${id}`, payload, jsonHeaders);
}

